import { render } from "./Login.vue?vue&type=template&id=7df0bb28&ts=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import exportComponent from "/home/arthur/ProjetoVue/revista/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__